(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["italcoffe-range"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    root.querySelectorAll('[data-itc]').forEach(function (sec) {
      if (sec.dataset.bound === '1') return;
      sec.dataset.bound = '1';

      function spines() { return Array.prototype.slice.call(sec.querySelectorAll('[data-itc-spine]')); }
      function glow(sp) {
        var c = sp.style.getPropertyValue('--c');
        if (c) sec.style.setProperty('--itc-active', c.trim());
      }
      function open(sp, focus) {
        spines().forEach(function (o) {
          var t = o === sp;
          o.classList.toggle('is-open', t);
          var tab = o.querySelector('[data-itc-tab]');
          if (tab) tab.setAttribute('aria-expanded', t ? 'true' : 'false');
        });
        glow(sp);
        if (focus) { var tb = sp.querySelector('[data-itc-tab]'); if (tb) tb.focus({ preventScroll: true }); }
      }

      sec.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-itc-tab]');
        if (!tab || !sec.contains(tab)) return;
        var sp = tab.closest('[data-itc-spine]');
        if (sp && !sp.classList.contains('is-open')) open(sp);
      });

      sec.addEventListener('keydown', function (e) {
        var tab = e.target.closest('[data-itc-tab]');
        if (!tab || e.target !== tab) return;
        var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!d) return;
        var a = spines(), cur = tab.closest('[data-itc-spine]');
        e.preventDefault();
        open(a[(a.indexOf(cur) + d + a.length) % a.length], true);
      });

      var first = sec.querySelector('[data-itc-spine].is-open') || sec.querySelector('[data-itc-spine]');
      if (first) glow(first);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else { bind(document); }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target.querySelector ? e.target.querySelector('[data-itc-tab]') : null;
    if (t) t.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
